import { render, staticRenderFns } from "./AttendanceHistory.vue?vue&type=template&id=0a00d03b&"
import script from "./AttendanceHistory.vue?vue&type=script&lang=js&"
export * from "./AttendanceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports